import React from 'react';

const services = [
    {
        id: "01",
        title: "L'image de marque",
        description: "Je crée des identités de marque distinctives qui résonnent et perdurent. Grâce à une vision stratégique et à une conception méticuleuse, je crée un langage visuel unifié qui capture votre essence et s'adresse à votre public."
    },
    {
        id: "02",
        title: "UI/UX",
        description: "Concevoir des expériences utilisateur intuitives et engageantes qui mélangent harmonieusement la forme et la fonction. Je me concentre sur la création d'interfaces qui ne sont pas seulement visuellement attrayantes, mais aussi profondément fonctionnelles et centrées sur l'utilisateur."
    },
    {
        id: "03",
        title: "Conception d'applications",
        description: "Transformer les idées en expériences applicatives captivantes. Je conçois avec précision et créativité, en veillant à ce que chaque interaction soit fluide et que chaque élément visuel renforce le plaisir et l'engagement de l'utilisateur."
    }
];

const Services = () => {
    return (
        <div className="row service-wrapper items mt-md-5">
            {services.map((service, index) => (
                <div key={index} className="col-12 col-md-6 col-lg-4">
                    <div className="item d-flex align-items-start">
                        <div className="item-count">{service.id}</div>
                        <div className="content">
                            <h4 className="mt-0">{service.title}</h4>
                            <p>{service.description}</p>
                        </div>
                    </div>
                </div>
            ))}
        </div>
    );
};

export default Services;
